import StockImportView from 'src/sections/stock/stock-import/view/stock-import-view';

export default function StockImportPage() {
  return <StockImportView />;
}
